<template lang="pug">
  sui-table-row.clickable(@click="$emit('click', match.matchId)")
    sui-table-cell(text-align="right") {{ awayTeam ? awayTeam.name : defaults.name }}
    sui-table-cell(text-align="left")
      h4(
        is="sui-header",
        image)
        sui-image(:src="awayTeam ? awayTeam.logo.main.svg : defaults.logo")

    sui-table-cell(
      text-align="right",
      v-if="isFutureMatch")
      strong {{ match.scores[0] }}

    sui-table-cell(
      text-align="left",
      :title="fullDate",
      v-if="isFutureMatch")
      strong {{ match.scores[1] }}

    sui-table-cell(
      colspan="2",
      text-align="center",
      :title="fullDate",
      v-else) {{ timeDiff }}

    sui-table-cell(text-align="right")
      h4(
        is="sui-header",
        image)
        sui-image(:src="homeTeam ? homeTeam.logo.main.svg : defaults.logo")

    sui-table-cell(text-align="left") {{ homeTeam ? homeTeam.name : defaults.name }}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'MatchRow',
  props: {
    match: {
      required: true,
    },
  },
  data() {
    return {
      DateTime,
      defaults: {
        name: '--',
        logo: '/logo-placeholder.svg',
      },
    };
  },
  computed: {
    isFutureMatch() {
      return DateTime.utc() - DateTime.fromISO(this.match.startDate) > 0;
    },
    fullDate() {
      return DateTime.fromISO(this.match.startDate).toLocaleString(DateTime.DATETIME_MED);
    },
    timeDiff() {
      const futureDate = DateTime.fromISO(this.match.startDate);
      const { days, hours } = futureDate.diff(DateTime.utc(), ['days', 'hours']).toObject();
      if (futureDate.day - DateTime.local().day === 1) {
        return `Tomorrow at ${futureDate.toFormat('h:mm a')}`;
      }
      if (!days) {
        return `In ${Math.round(hours)} hours`;
      }
      return futureDate.toLocaleString(DateTime.DATETIME_MED);
    },
    awayTeam() {
      return this.match.teams[0];
    },
    homeTeam() {
      return this.match.teams[1];
    },
  },
};
</script>
